import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

let firebaseApp: any = null;
let auth: any = null;

// Initialize Firebase with config from environment variables
const initializeFirebase = async () => {
  if (firebaseApp) return { app: firebaseApp, auth };

  try {
    const firebaseConfig: FirebaseConfig = {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "",
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "",
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "",
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "",
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "",
      appId: import.meta.env.VITE_FIREBASE_APP_ID || "",
    };

    // Validate that all required config is present
    const missingKeys = Object.entries(firebaseConfig)
      .filter(([_, value]) => !value)
      .map(([key, _]) => key);

    if (missingKeys.length > 0) {
      throw new Error(`Missing Firebase configuration: ${missingKeys.join(", ")}. Ensure environment variables are set in Cloudflare Pages.`);
    }

    // Initialize Firebase with the config from environment variables
    firebaseApp = initializeApp(firebaseConfig);
    auth = getAuth(firebaseApp);

    // Don't connect to emulator for now - uncomment if you set up Firebase emulator
    // if (import.meta.env.DEV) {
    //   try {
    //     connectAuthEmulator(auth, 'http://localhost:9099');
    //   } catch (error) {
    //     console.log('Auth emulator connection skipped:', error);
    //   }
    // }

    return { app: firebaseApp, auth };
  } catch (error) {
    console.error("Failed to initialize Firebase:", error);
    throw new Error(`Firebase initialization failed: ${error instanceof Error ? error.message : "Unknown error"}`);
  }
};

// Export a promise that resolves to the initialized auth
export const getFirebaseAuth = async () => {
  const { auth } = await initializeFirebase();
  if (!auth) {
    throw new Error("Firebase Auth could not be initialized");
  }
  return auth;
};

// For backwards compatibility, export auth that will be initialized
export { auth };

export default firebaseApp;
